<template>
	<!--扩展信息-->
	<section class="extend-info publish-main">
		<el-form ref="form" :model="form" size="small" :rules="rules" label-width="130px">

			<title-area title="应用名称">

				<el-form-item label="应用名称：">
					<el-input class="auto-width" v-model="form.appName" disabled/>
				</el-form-item>

				<el-form-item label="英文名称：" prop="appEnName">
					<el-input class="auto-width" v-model="form.appEnName" :disabled="hid" maxlength="60" placeholder="最多输入60个字符，只允许英文和数字"/>
					<span class="hints">最多输入60个字符，只允许英文和数字</span>
				</el-form-item>

				<el-form-item label="桌面显示名称：" prop="viewName">
					<el-input class="auto-width" v-model="form.viewName" :disabled="hid" maxlength="6"  placeholder="显示在桌面的名称"/>
					<span class="hints">最多输入6个汉字</span>
				</el-form-item>

			</title-area>

			<title-area title="版本编号">

				<el-form-item prop="versionNo">
					<el-input v-model="form.versionNo" class="auto-width" :disabled="hidsubv" maxlength="20" placeholder="英文和数字以及“.”20字符以内"/>
					<span class="hints">与安装包版本号一致</span>
				</el-form-item>

			</title-area>

			<title-area title="数据服务包">
				<el-form-item label="增值服务：" prop="addservicesCheck">
					<el-checkbox-group v-model="form.addservicesCheck">
				    <el-checkbox class="check-list" :disabled="hid" :label="item.id" v-for="(item, index) in appAddServices" :key="item.id">{{item.dictionaryname}}</el-checkbox>
				  </el-checkbox-group>
				</el-form-item>

				<el-form-item label="数据接口权限：" prop="interfaceCheck">
					<el-checkbox-group v-model="form.interfaceCheck">
				    <el-checkbox class="check-list" :disabled="hid" :label="item.id" v-for="(item, index) in appInterface" :key="item.id">{{item.dictionaryname}}</el-checkbox>
				  </el-checkbox-group>
				</el-form-item>

			</title-area>

			<title-area :title="deployType == 109002 ? '部署应用' : '访问地址'">

				<!--容器化应用-->
				<el-form-item label="上传安装包" prop="appInstallpackagePath" label-width="100px" v-if="deployType == 109002">
					<div class="upload-wrap" :disabled="hidsubv">
						<el-upload
						  class="avatar-uploader"
						  action="/zklccloud/upload"
						  :show-file-list="false"
						  :on-success="handleAvatarSuccess"
						  :on-progress="uploadprogress"
						  :data="{'access_token':accessToken}"
						  :disabled="uploadDisabled">
						  <!--↑ 注意disabled-->

						  <img v-if="uploadDisabled" src="../img/icon-azb.png" class="avatar">
						  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
						  <div class="name text-space" v-if="uploadDisabled">{{originalFilename}}</div>
						</el-upload>

						<i class="el-icon-circle-close cursor" v-if="uploaddel" @click.stop.self.prevent="delAzb"></i>
					</div>
					<el-progress :class="{ 'is-visibility' : progress === 0 || progress === 100 }" :percentage="progress" style="width: 198px;"></el-progress>

				</el-form-item>

				<!--sass应用-->
				<el-form-item v-else label-width="0" prop="visitUrl">
					<el-input style="width: 600px;"v-model="form.visitUrl" maxlength="500"/>
				</el-form-item>

			</title-area>

			<title-area title="应用介绍" :margin-left="56" :padding-right="60" :dashed="false">
				<el-form-item  prop="appComment" label-width="0">
					<el-input
					  type="textarea"
					  :rows="4"
					  placeholder="请输入内容"
					  v-model="form.appComment" :disabled="hid">
					</el-input>
				</el-form-item>
			</title-area>



		</el-form>
	</section>
</template>

<script>
	import titleArea from './title_area'
	export default {
		name: 'vExtInfo',

		data() {
			var validateEnName = (rule, value, callback) => {
				      if((/[^a-zA-Z0-9]/g.test(value)))
				      {
				      	callback(new Error('英文名称最多输入60个字符，只允许英文和数字'));
				      }
				      else
				      {
				      	callback();
				      }
				};
			var validateVersion = (rule, value, callback) => {
			      if((/[^a-z0-9.]/g).test(value))
			      {
			      	callback(new Error('编号只允许小写英文和数字以及“.”,限20字符以内'));
			      }
			      else
			      {
			      	callback();
			      }
			};
			var validateAppComment = (rule, value, callback) => {
			      if(20 > value.length)
			      {
			      	callback(new Error('应用介绍描述字数小于20字'));
			      }
			      else
			      {
			      	callback();
			      }
			};
			return {
				accessToken: localStorage.getItem('token'),
				hid: false,
				hidsub: false,
				hidsubv: false,
				uploaddel:false,
				deployType:109002,
				form: {
					appName:'',
					appEnName:'',
					viewName:'',
					versionNo:'',
					addservicesCheck:[],
					interfaceCheck:[],
					appComment:'',
					appInstallpackagePath:'',
					visitUrl:'',
					packageName:''
				},
				rules: { //表单的验证规则
					appEnName: [
						{ required: true, message: '英文名称', trigger: 'change' },{ validator: validateEnName,  trigger: 'change' },
					],
					viewName: [
						{ required: true, message: '桌面显示名称', trigger: 'change' }
					],
					versionNo:[
						{ required: true, message: '版本号', trigger: 'change' },{validator:validateVersion,  trigger: 'change' }
					],
					addservicesCheck:[
						{ required: true, message: '增值服务', trigger: 'change' }
					],
					interfaceCheck:[
						{ required: true, message: '数据接口', trigger: 'change' }
					],
					appComment:[
						{ required: true, message: '应用介绍', trigger: 'change' },{validator:validateAppComment,  trigger: 'change' }
					],
					appInstallpackagePath:[
						{ required: true, message: '上传应用包', trigger: 'change' }
					],
					visitUrl:[
					    { required: true, message: '访问地址', trigger: 'change' }
					]
				},
				uploadDisabled: false,
				progress: 0,//进度
				appAddServices:this.data.appAddServices,
				appInterface:this.data.appInterface,
				progress:0,
				originalFilename:'',
      }
		},

		components: {
			titleArea,
		},

		props: {
			data: {}
		},

		mounted: function() {
			this.$nextTick(function() {
				this.form.appName = this.$parent.tCloudApp.appName;
				this.form.appEnName = this.$parent.tCloudApp.appEnName;
				this.form.viewName = this.$parent.tCloudApp.viewName;
				this.form.versionNo = this.$parent.tCloudAppVersion.versionNo;
				this.deployType = this.$parent.tCloudApp.deployType;
				this.form.visitUrl = this.$parent.tCloudAppVersion.visitUrl;
				this.form.packageName = this.$parent.tCloudAppVersion.packageName;
				var arr = this.$parent.tCloudAppVersion.addserviceApis.split(",");
				if(arr.length != 0 && '' != arr[0])
				{
					for(var i = 0;i < arr.length;i++)
					{
						this.form.addservicesCheck.push(parseInt(arr[i]));
					}	
				}
				var arr1 = this.$parent.tCloudAppVersion.misdataApis.split(",");
				if(arr1.length !=0  && '' != arr1[0])
				{
					for(var i = 0;i < arr1.length;i++)
					{
						this.form.interfaceCheck.push(parseInt(arr1[i]));
					}
				}
				this.form.appComment = this.$parent.tCloudAppVersion.appComment;
				this.form.appInstallpackagePath = this.$parent.tCloudAppVersion.appInstallpackagePath;
				this.originalFilename = this.$parent.tCloudAppVersion.packageName;
				this.hid = this.$parent.hid;
				this.hidsub = this.$parent.hidsub;
				this.hidsubv = this.$parent.hidsubv;
				if(null != this.originalFilename && '' != this.originalFilename)
				{
					this.uploadDisabled = true;
				}
				if(null != this.originalFilename && !this.hidsubv && '' != this.originalFilename)
				{
					this.uploaddel = true;
				}
			})
		},

		methods: {
	 handleAvatarSuccess(res, file,fileList) {
		//上传成功
		this.originalFilename = res.content.originalFilename;
		this.form.packageName = res.content.originalFilename;
		console.log(this.form.packageName);
		this.form.appInstallpackagePath = res.content.filepath;
		this.uploadDisabled = true;
		this.uploaddel = true;
      },

      beforeAvatarUpload(file) {
      	//上传之前校验
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      uploadprogress(event, file, fileList){
      	var completePercent = Math.round(event.loaded / event.total * 100);
      	this.progress = completePercent
      },

      delAzb() {
      	//删除安装包
      	this.uploaddel = false;
      	this.uploadDisabled = false;
      	this.originalFilename = '';
      	this.form.packageName = "";
      	this.form.appInstallpackagePath = "";
      },
      verify() { //form表单的校验结果
				let flag;
				this.$refs['form'].validate((valid) => {
					if(valid) {
						flag = true;
					} else {
						console.log('error submit!!');
						flag = false;
						return false;
					}
				});
				if(flag)
				{
					return {
						flag: flag,
						status: 3,
						form: this.form
					};
				}
			},
	    saveverify() { //form表单的校验结果
				return {
					flag: true,
					status: 3,
					form: this.form
				};
			},
		}
	}
</script>

<style>
.upload-wrap {
	position: relative;
	width: 148px;
}
.upload-wrap .avatar-uploader .el-upload {
	width: 148px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  padding: 20px 20px 10px;
}
.upload-wrap .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.upload-wrap .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106px;
  height: 127px;
  line-height: 127px;
  text-align: center;
}
.upload-wrap .avatar {
  display: block;
}

.upload-wrap .name {
	font-size: 12px;
	color: #333;
}
.upload-wrap .el-icon-circle-close {
	position: absolute;
	top: -5px;
	right: -5px;
	z-index: 9;
	color: #FF1212;
}
</style>


// WEBPACK FOOTER //
// ext_info.vue?13299eb6